import { render, staticRenderFns } from "./HostingBackup.vue?vue&type=template&id=74544335&"
import script from "./HostingBackup.vue?vue&type=script&lang=js&"
export * from "./HostingBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports